import type * as lazyIndex from "./lazyIndex";
import { type LazyComponent, LazyModule, createLazyComponent } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "AuthStepupDialog" */ "./lazyIndex"), { name: "AuthStepupDialog" });

export const AuthStepupDialog: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.AuthStepupDialog);

// TODO: in followup, export mutators and selectors
